import { 
    CONTACT_PAGE_URL, 
    HOME_PAGE_URL, 
    ABOUT_PAGE_URL, 
    LINKS_PAGE_URL, 
    CLIPS_FANSITES_PAGE_URL, 
    SERVICES_PAGE_URL, 
    GALLERY_PAGE_URL, 
    TESTIMONIALS_PAGE_URL 
  } from '../Routes';
  
  export const FooterLinksArray = [
    { name: 'Home', route: HOME_PAGE_URL },
    { name: 'About Me', route: ABOUT_PAGE_URL },
    { name: 'Services', route: SERVICES_PAGE_URL },
    { name: 'Gallery', route: GALLERY_PAGE_URL },
    { name: 'Clips/Fansites', route: CLIPS_FANSITES_PAGE_URL },
    { name: 'Links', route: LINKS_PAGE_URL },
    { name: 'Testimonials', route: TESTIMONIALS_PAGE_URL },
    { name: 'Contact', route: CONTACT_PAGE_URL },
  ];
  